export default __webpack_public_path__ + "static/media/catalin-bara.174a235c.png";